import axios from "axios";
import { getApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";

const getAuthHeaders = () => ({ Authorization: getAuthUser()?.accessToken });

export interface SubscriberEvent {
  type: string;
  timestamp: string;
  edition_id: number;
  edition_title: string | null;
  original_link: string | null;
  verified?: boolean;
}

export interface SubscriberStats {
  total_delivered: number;
  total_opens: number;
  total_clicks: number;
  unique_opens: number;
  unique_clicks: number;
  unique_open_rate: number;
  unique_click_rate: number;
  verified_clicks: number;
  unique_verified_clicks: number;
  verified_click_rate: number;
}

export interface SubscriberStatsResponse {
  subscriber_id: number;
  email: string;
  status: string;
  custom_fields?: Record<string, string | number | boolean | null>;
  subscribed_at: string;
  source: string | null;
  last_opened_at: string | null;
  last_delivered_at: string | null;
  stats: SubscriberStats;
}

export interface PaginatedEventsResponse {
  events: SubscriberEvent[];
  page: number;
  per_page: number;
  total_count: number;
  total_pages: number;
  has_more: boolean;
  source: string;
}

// Keep the old combined type for backward compatibility
export interface SubscriberEventsResponse {
  subscriber_id: number;
  email: string;
  status: string;
  custom_fields?: Record<string, string | number | boolean | null>;
  subscribed_at: string;
  source: string | null;
  last_opened_at: string | null;
  last_delivered_at: string | null;
  stats: SubscriberStats;
  start_date?: string;
  end_date?: string;
  events: SubscriberEvent[];
  count: number;
}

export const getSubscriberStats = async (
  subscriberId: string
): Promise<SubscriberStatsResponse> => {
  const response = await axios.get(
    `${getApiUrlWithVersion()}/subscribers/${subscriberId}/stats`,
    {
      headers: getAuthHeaders(),
    }
  );
  return response.data;
};

export const getSubscriberEvents = async (
  subscriberId: string,
  page: number = 1,
  perPage: number = 10,
  startDate?: string,
  endDate?: string
): Promise<PaginatedEventsResponse> => {
  const params: any = { page, per_page: perPage };
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;

  const response = await axios.get(
    `${getApiUrlWithVersion()}/subscribers/${subscriberId}/events`,
    {
      headers: getAuthHeaders(),
      params,
    }
  );
  return response.data;
};
